import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../Components/Spinner/Spinner";
import Swal from "sweetalert2";
import { clearErrors, login } from "../../actions/userActions";
import "./Signin.css";
import { useHistory } from "react-router-dom";

function Signin() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [errors, setErrors] = useState({});

  const [load, setLoad] = useState(false);

  const { user, isAuthenticated, error } = useSelector((state) => state.auth);
  console.log(user, isAuthenticated, error);
  useEffect(() => {
    if (isAuthenticated) {
      if (user.token) localStorage.setItem("token", user.token);
      // setLoad(false);
      if (data.email) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Signed-in Successfully!",
          timer: 2000,
          showConfirmButton: false,
        });
      }

      history.push("/");
    }

    if (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: error,
        showConfirmButton: false,

        timer: 2000,
      });
      dispatch(clearErrors());
    }
  }, [dispatch, isAuthenticated, history, error]);

  useEffect(() => {
    if (Object.keys(errors).length !== 0) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please fill all input fields",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  }, [errors]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const valid = validation();

    if (valid > 0) return;
    // setLoad(true)
    dispatch(login(data, history, setLoad));
  };

  const validation = () => {
    let errors = {};
    if (!data.password) errors.password = "Password is required";
    if (!data.email) errors.email = "Email is required";

    setErrors(errors);
    return Object.keys(errors).length;
  };

  if (load) {
    return <LoadingSpinner />;
  }
  return (
    // {loa : }
    <div className="signinpage">
      {/* <form onSubmit={(e)=>{signin(e)}}>
        <input onChange={(e)=>{setEmail(e.target.value)}} />
      </form> */}
      <div className="doctor_div">
        <div className="doctor_img_login">
          <img alt="logo" src="/img/ladydoctor.jpg"></img>
        </div>
      </div>

      <div className="sign_in_page">
        <div className="white_back">
          <div className="sign_logo">
            <Link to="/">
              <img alt="logo" src="/img/logo1.png"></img>
            </Link>
          </div>
          <p className="signin_heading">SIGN IN AS A PATIENT</p>
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            onChange={(e) => {
              setData({ ...data, [e.target.name]: e.target.value });
            }}
          >
            <div className="input_sign_div">
              <div className="input_1">
                <img alt={"mail"} src="/img/mail.svg" />
                <input
                  name="email"
                  type="email"
                  className={errors.email ? "signin_input_error" : "sign_input"}
                  placeholder="Email Address"
                  required
                />
              </div>
              <div className="input_2">
                <img alt={"logo"} src="/img/smart-key.svg" />
                <input
                  name="password"
                  type="password"
                  required
                  className={
                    errors.password ? "signin_input_error" : "sign_input"
                  }
                  placeholder="Password"
                />
                <div
                  // style={{ fontWeight: "unset" }}
                  className="text_right for"
                >
                  <a href="/forget-password">Forgot Password? </a>
                </div>
              </div>

              <div
                className="sign_menu"
                onClick={(e) => {
                  handleSubmit(e);
                }}
              >
                <button
                  style={{
                    background: "#02c4b7",
                    color: "#fff",
                    padding: "10px 17px",
                    paddingRight: "48px",
                    borderRadius: "5px",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "900",
                    position: "relative",
                    boxShadow: "0px 1px 5px rgb(136 135 135 / 80%)",
                    display: "inline-block",
                    border: "none",
                  }}
                  type="submit"
                  className="themebutton_end "
                >
                  SIGN IN
                </button>
                <a>
                  <div className="img_wrap_end" style={{ height: "40px" }}>
                    <img alt="logo" src="/img/chevron-right.svg" />
                  </div>
                </a>
              </div>

              <div className="get_sign_up_div">
                Don't have an account?
                <span>
                  <Link to="/sign-up">
                    <span className="span_item" style={{ marginLeft: "10px" }}>
                      SIGN UP
                    </span>
                  </Link>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Signin;
